import * as i0 from '@angular/core';
import { forwardRef, Directive, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const VALUE_CONTROL_ACCESSOR$4 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ValueControlValueAccessor),
    multi: true,
};
/**
 * @description
 * A `ControlValueAccessor` for writing a value and listening to changes on a checkbox input
 * element.
 *
 * @ngModule FormsModule
 * @publicApi
 */
class ValueControlValueAccessor {
    constructor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = (_) => { };
        /**
         * @description
         * The registered callback function called when a blur event occurs on the input element.
         */
        this.onTouched = () => { };
    }
    onChangeListener(value) {
        this.onChange(value);
    }
    onInputListener(value) {
        this.onChange(value);
    }
    onBlurListener() {
        this.onTouched();
    }
    /**
     * Sets the "checked" property on the input element.
     *
     * @param value The checked value
     */
    writeValue(value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', value);
    }
    /**
     * @description
     * Registers a function called when the control value changes.
     *
     * @param fn The callback function
     */
    registerOnChange(fn) { this.onChange = fn; }
    /**
     * @description
     * Registers a function called when the control is touched.
     *
     * @param fn The callback function
     */
    registerOnTouched(fn) { this.onTouched = fn; }
    /**
     * Sets the "disabled" property on the input element.
     *
     * @param isDisabled The disabled value
     */
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    }
}
ValueControlValueAccessor.ɵfac = function ValueControlValueAccessor_Factory(t) { return new (t || ValueControlValueAccessor)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef)); };
ValueControlValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ValueControlValueAccessor, selectors: [["davinci-text-field", "formControlName", ""], ["davinci-text-field", "formControl", ""], ["davinci-text-field", "ngModel", ""], ["davinci-auto-suggest", "formControlName", ""], ["davinci-auto-suggest", "formControl", ""], ["davinci-auto-suggest", "ngModel", ""], ["davinci-drop-down", "formControlName", ""], ["davinci-drop-down", "formControl", ""], ["davinci-drop-down", "ngModel", ""], ["davinci-text-area", "formControlName", ""], ["davinci-text-area", "formControl", ""], ["davinci-text-area", "ngModel", ""], ["davinci-tag-module", "formControlName", ""], ["davinci-tag-module", "formControl", ""], ["davinci-tag-module", "ngModel", ""], ["davinci-slider", "formControlName", ""], ["davinci-slider", "formControl", ""], ["davinci-slider", "ngModel", ""], ["davinci-flexi-slider", "formControlName", ""], ["davinci-flexi-slider", "formControl", ""], ["davinci-flexi-slider", "ngModel", ""], ["davinci-toggle-group", "formControlName", ""], ["davinci-toggle-group", "formControl", ""], ["davinci-toggle-group", "ngModel", ""], ["davinci-numeric-field", "formControlName", ""], ["davinci-numeric-field", "formControl", ""], ["davinci-numeric-field", "ngModel", ""], ["davinci-search-field", "formControlName", ""], ["davinci-search-field", "formControl", ""], ["davinci-search-field", "ngModel", ""], ["davinci-value-display", "formControlName", ""], ["davinci-value-display", "formControl", ""], ["davinci-value-display", "ngModel", ""]], hostBindings: function ValueControlValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("change", function ValueControlValueAccessor_change_HostBindingHandler($event) { return ctx.onChangeListener($event.target.value); })("input", function ValueControlValueAccessor_input_HostBindingHandler($event) { return ctx.onInputListener($event.target.value); })("blur", function ValueControlValueAccessor_blur_HostBindingHandler() { return ctx.onBlurListener(); });
    } }, features: [i0.ɵɵProvidersFeature([VALUE_CONTROL_ACCESSOR$4])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValueControlValueAccessor, [{
        type: Directive,
        args: [{
                /* eslint-disable */
                selector: `davinci-text-field[formControlName],davinci-text-field[formControl],davinci-text-field[ngModel],
  davinci-auto-suggest[formControlName],davinci-auto-suggest[formControl],davinci-auto-suggest[ngModel],
  davinci-drop-down[formControlName],davinci-drop-down[formControl],davinci-drop-down[ngModel],
  davinci-text-area[formControlName],davinci-text-area[formControl],davinci-text-area[ngModel],
  davinci-tag-module[formControlName],davinci-tag-module[formControl],davinci-tag-module[ngModel],
  davinci-slider[formControlName],davinci-slider[formControl],davinci-slider[ngModel],
  davinci-flexi-slider[formControlName],davinci-flexi-slider[formControl],davinci-flexi-slider[ngModel],
  davinci-toggle-group[formControlName],davinci-toggle-group[formControl],davinci-toggle-group[ngModel],
  davinci-numeric-field[formControlName],davinci-numeric-field[formControl],davinci-numeric-field[ngModel],
  davinci-search-field[formControlName],davinci-search-field[formControl],davinci-search-field[ngModel],
  davinci-value-display[formControlName],davinci-value-display[formControl],davinci-value-display[ngModel]
  `,
                /* eslint-enable */
                providers: [VALUE_CONTROL_ACCESSOR$4]
            }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, { onChangeListener: [{
            type: HostListener,
            args: ['change', ['$event.target.value']]
        }], onInputListener: [{
            type: HostListener,
            args: ['input', ['$event.target.value']]
        }], onBlurListener: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const VALUE_CONTROL_ACCESSOR$3 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectedControlValueAccessor),
    multi: true,
};
/**
 * @description
 * A `ControlValueAccessor` for writing a value and listening to changes on a checkbox input
 * element.
 *
 * @ngModule FormsModule
 * @publicApi
 */
class SelectedControlValueAccessor {
    constructor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = (_) => { };
        /**
         * @description
         * The registered callback function called when a blur event occurs on the input element.
         */
        this.onTouched = () => { };
    }
    onChangeListener(value) {
        this.onChange(value);
    }
    onBlurListener() {
        this.onTouched();
    }
    /**
     * Sets the "checked" property on the input element.
     *
     * @param value The checked value
     */
    writeValue(value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'selected', value);
    }
    /**
     * @description
     * Registers a function called when the control value changes.
     *
     * @param fn The callback function
     */
    registerOnChange(fn) { this.onChange = fn; }
    /**
     * @description
     * Registers a function called when the control is touched.
     *
     * @param fn The callback function
     */
    registerOnTouched(fn) { this.onTouched = fn; }
    /**
     * Sets the "disabled" property on the input element.
     *
     * @param isDisabled The disabled value
     */
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    }
}
SelectedControlValueAccessor.ɵfac = function SelectedControlValueAccessor_Factory(t) { return new (t || SelectedControlValueAccessor)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef)); };
SelectedControlValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: SelectedControlValueAccessor, selectors: [["davinci-button", "toggle", "", "formControlName", ""], ["davinci-button", "toggle", "", "formControl", ""], ["davinci-button", "toggle", "", "ngModel", ""]], hostBindings: function SelectedControlValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("change", function SelectedControlValueAccessor_change_HostBindingHandler($event) { return ctx.onChangeListener($event.target.selected); })("blur", function SelectedControlValueAccessor_blur_HostBindingHandler() { return ctx.onBlurListener(); });
    } }, features: [i0.ɵɵProvidersFeature([VALUE_CONTROL_ACCESSOR$3])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedControlValueAccessor, [{
        type: Directive,
        args: [{
                selector: `davinci-button[toggle][formControlName],davinci-button[toggle][formControl],davinci-button[toggle][ngModel]`,
                providers: [VALUE_CONTROL_ACCESSOR$3]
            }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, { onChangeListener: [{
            type: HostListener,
            args: ['change', ['$event.target.selected']]
        }], onBlurListener: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const VALUE_CONTROL_ACCESSOR$2 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckedControlValueAccessor),
    multi: true,
};
/**
 * @description
 * A `ControlValueAccessor` for writing a value and listening to changes on a checkbox input
 * element.
 *
 * @ngModule FormsModule
 * @publicApi
 */
class CheckedControlValueAccessor {
    constructor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = (_) => { };
        /**
         * @description
         * The registered callback function called when a blur event occurs on the input element.
         */
        this.onTouched = () => { };
    }
    /* eslint-enable */
    onChangeListener(value) {
        this.onChange(value);
    }
    onBlurListener() {
        this.onTouched();
    }
    /**
     * Sets the "checked" property on the input element.
     *
     * @param value The checked value
     */
    writeValue(value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
    }
    /**
     * @description
     * Registers a function called when the control value changes.
     *
     * @param fn The callback function
     */
    registerOnChange(fn) { this.onChange = fn; }
    /**
     * @description
     * Registers a function called when the control is touched.
     *
     * @param fn The callback function
     */
    registerOnTouched(fn) { this.onTouched = fn; }
    /**
     * Sets the "disabled" property on the input element.
     *
     * @param isDisabled The disabled value
     */
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    }
}
CheckedControlValueAccessor.ɵfac = function CheckedControlValueAccessor_Factory(t) { return new (t || CheckedControlValueAccessor)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef)); };
CheckedControlValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: CheckedControlValueAccessor, selectors: [["davinci-checkbox", "formControlName", ""], ["davinci-checkbox", "formControl", ""], ["davinci-checkbox", "ngModel", ""], ["davinci-toggle-switch", "formControlName", ""], ["davinci-toggle-switch", "formControl", ""], ["davinci-toggle-switch", "ngModel", ""], ["davinci-radio-button", "formControlName", ""], ["davinci-radio-button", "formControl", ""], ["davinci-radio-button", "ngModel", ""]], hostBindings: function CheckedControlValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("change", function CheckedControlValueAccessor_change_HostBindingHandler($event) { return ctx.onChangeListener($event.target.checked); })("blur", function CheckedControlValueAccessor_blur_HostBindingHandler() { return ctx.onBlurListener(); });
    } }, features: [i0.ɵɵProvidersFeature([VALUE_CONTROL_ACCESSOR$2])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckedControlValueAccessor, [{
        type: Directive,
        args: [{
                /* eslint-disable */
                selector: `davinci-checkbox[formControlName],davinci-checkbox[formControl],davinci-checkbox[ngModel],
             davinci-toggle-switch[formControlName],davinci-toggle-switch[formControl],davinci-toggle-switch[ngModel],
             davinci-radio-button[formControlName],davinci-radio-button[formControl],davinci-radio-button[ngModel]`,
                /* eslint-enable */
                providers: [VALUE_CONTROL_ACCESSOR$2]
            }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, { onChangeListener: [{
            type: HostListener,
            args: ['change', ['$event.target.checked']]
        }], onBlurListener: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const VALUE_CONTROL_ACCESSOR$1 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ArrayControlValueAccessor),
    multi: true,
};
/**
 * @description
 * A `ControlValueAccessor` for writing a value and listening to changes on a checkbox input
 * element.
 *
 * @ngModule FormsModule
 * @publicApi
 */
class ArrayControlValueAccessor {
    constructor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = (_) => { };
        /**
         * @description
         * The registered callback function called when a blur event occurs on the input element.
         */
        this.onTouched = () => { };
    }
    onChangeListener(value) {
        if (Array.isArray(value)) {
            value = [...value];
        }
        this.onChange(value);
    }
    onInputListener(value) {
        if (Array.isArray(value)) {
            value = [...value];
        }
        this.onChange(value);
    }
    onBlurListener() {
        this.onTouched();
    }
    /**
     * Sets the "value" property on the input element.
     *
     * @param value The value value
     */
    writeValue(value) {
        if (!Array.isArray(value)) {
            try {
                value = JSON.parse(value);
            }
            catch (e) { }
        }
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', value);
    }
    /**
     * @description
     * Registers a function called when the control value changes.
     *
     * @param fn The callback function
     */
    registerOnChange(fn) { this.onChange = fn; }
    /**
     * @description
     * Registers a function called when the control is touched.
     *
     * @param fn The callback function
     */
    registerOnTouched(fn) { this.onTouched = fn; }
    /**
     * Sets the "disabled" property on the input element.
     *
     * @param isDisabled The disabled value
     */
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    }
}
ArrayControlValueAccessor.ɵfac = function ArrayControlValueAccessor_Factory(t) { return new (t || ArrayControlValueAccessor)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef)); };
ArrayControlValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ArrayControlValueAccessor, selectors: [["davinci-range-slider", "formControlName", ""], ["davinci-range-slider", "formControl", ""], ["davinci-range-slider", "ngModel", ""]], hostBindings: function ArrayControlValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("change", function ArrayControlValueAccessor_change_HostBindingHandler($event) { return ctx.onChangeListener($event.target.value); })("input", function ArrayControlValueAccessor_input_HostBindingHandler($event) { return ctx.onInputListener($event.target.value); })("blur", function ArrayControlValueAccessor_blur_HostBindingHandler() { return ctx.onBlurListener(); });
    } }, features: [i0.ɵɵProvidersFeature([VALUE_CONTROL_ACCESSOR$1])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ArrayControlValueAccessor, [{
        type: Directive,
        args: [{
                selector: `davinci-range-slider[formControlName],davinci-range-slider[formControl],davinci-range-slider[ngModel]`,
                providers: [VALUE_CONTROL_ACCESSOR$1]
            }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, { onChangeListener: [{
            type: HostListener,
            args: ['change', ['$event.target.value']]
        }], onInputListener: [{
            type: HostListener,
            args: ['input', ['$event.target.value']]
        }], onBlurListener: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const VALUE_CONTROL_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => StatusControlValueAccessor),
    multi: true,
};
/**
 * @description
 * A `ControlValueAccessor` for writing a value and listening to changes on a checkbox input
 * element.
 *
 * @ngModule FormsModule
 * @publicApi
 */
class StatusControlValueAccessor {
    constructor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = (_) => { };
        /**
         * @description
         * The registered callback function called when a blur event occurs on the input element.
         */
        this.onTouched = () => { };
    }
    onChangeListener(value) {
        this.onChange(value);
    }
    onBlurListener() {
        this.onTouched();
    }
    /**
     * Sets the "checked" property on the input element.
     *
     * @param value The checked value
     */
    writeValue(value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'status', value);
    }
    /**
     * @description
     * Registers a function called when the control value changes.
     *
     * @param fn The callback function
     */
    registerOnChange(fn) { this.onChange = fn; }
    /**
     * @description
     * Registers a function called when the control is touched.
     *
     * @param fn The callback function
     */
    registerOnTouched(fn) { this.onTouched = fn; }
    /**
     * Sets the "disabled" property on the input element.
     *
     * @param isDisabled The disabled value
     */
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    }
}
StatusControlValueAccessor.ɵfac = function StatusControlValueAccessor_Factory(t) { return new (t || StatusControlValueAccessor)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef)); };
StatusControlValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StatusControlValueAccessor, selectors: [["davinci-status-indicator", "formControlName", ""], ["davinci-status-indicator", "formControl", ""], ["davinci-status-indicator", "ngModel", ""]], hostBindings: function StatusControlValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("change", function StatusControlValueAccessor_change_HostBindingHandler($event) { return ctx.onChangeListener($event.target.status); })("blur", function StatusControlValueAccessor_blur_HostBindingHandler() { return ctx.onBlurListener(); });
    } }, features: [i0.ɵɵProvidersFeature([VALUE_CONTROL_ACCESSOR])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatusControlValueAccessor, [{
        type: Directive,
        args: [{
                selector: `davinci-status-indicator[formControlName],davinci-status-indicator[formControl],davinci-status-indicator[ngModel]`,
                providers: [VALUE_CONTROL_ACCESSOR]
            }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, { onChangeListener: [{
            type: HostListener,
            args: ['change', ['$event.target.status']]
        }], onBlurListener: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const VALUES_CONTROL_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ValuesControlValueAccessor),
    multi: true,
};
// TODO: Remove this directive and add the davinci-multi-select to the array-control-value-accessor
// as soon as the api of the multi select was adapted, so it has no longer a _values_ but a _value_ property
/**
 * @description
 * A `ControlValueAccessor` for writing a value and listening to changes on a checkbox input
 * element.
 *
 * @ngModule FormsModule
 * @publicApi
 */
class ValuesControlValueAccessor {
    constructor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = (_) => { };
        /**
         * @description
         * The registered callback function called when a blur event occurs on the input element.
         */
        this.onTouched = () => { };
    }
    onChangeListener(value) {
        if (Array.isArray(value)) {
            value = [...value];
        }
        this.onChange(value);
    }
    onInputListener(value) {
        if (Array.isArray(value)) {
            value = [...value];
        }
        this.onChange(value);
    }
    onBlurListener() {
        this.onTouched();
    }
    /**
     * Sets the "value" property on the input element.
     *
     * @param value The value value
     */
    writeValue(value) {
        if (!Array.isArray(value)) {
            try {
                value = JSON.parse(value);
            }
            catch (e) { }
        }
        this._renderer.setProperty(this._elementRef.nativeElement, 'values', value);
    }
    /**
     * @description
     * Registers a function called when the control value changes.
     *
     * @param fn The callback function
     */
    registerOnChange(fn) { this.onChange = fn; }
    /**
     * @description
     * Registers a function called when the control is touched.
     *
     * @param fn The callback function
     */
    registerOnTouched(fn) { this.onTouched = fn; }
    /**
     * Sets the "disabled" property on the input element.
     *
     * @param isDisabled The disabled value
     */
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    }
}
ValuesControlValueAccessor.ɵfac = function ValuesControlValueAccessor_Factory(t) { return new (t || ValuesControlValueAccessor)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef)); };
ValuesControlValueAccessor.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ValuesControlValueAccessor, selectors: [["davinci-multi-select", "formControlName", ""], ["davinci-multi-select", "formControl", ""], ["davinci-multi-select", "ngModel", ""]], hostBindings: function ValuesControlValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("change", function ValuesControlValueAccessor_change_HostBindingHandler($event) { return ctx.onChangeListener($event.target.values); })("input", function ValuesControlValueAccessor_input_HostBindingHandler($event) { return ctx.onInputListener($event.target.values); })("blur", function ValuesControlValueAccessor_blur_HostBindingHandler() { return ctx.onBlurListener(); });
    } }, features: [i0.ɵɵProvidersFeature([VALUES_CONTROL_ACCESSOR])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValuesControlValueAccessor, [{
        type: Directive,
        args: [{
                selector: `davinci-multi-select[formControlName],davinci-multi-select[formControl],davinci-multi-select[ngModel]`,
                providers: [VALUES_CONTROL_ACCESSOR]
            }]
    }], function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }]; }, { onChangeListener: [{
            type: HostListener,
            args: ['change', ['$event.target.values']]
        }], onInputListener: [{
            type: HostListener,
            args: ['input', ['$event.target.values']]
        }], onBlurListener: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

class BasicElementsFormLibModule {
}
BasicElementsFormLibModule.ɵfac = function BasicElementsFormLibModule_Factory(t) { return new (t || BasicElementsFormLibModule)(); };
BasicElementsFormLibModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: BasicElementsFormLibModule });
BasicElementsFormLibModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasicElementsFormLibModule, [{
        type: NgModule,
        args: [{
                declarations: [ValueControlValueAccessor,
                    SelectedControlValueAccessor,
                    CheckedControlValueAccessor,
                    ArrayControlValueAccessor,
                    StatusControlValueAccessor,
                    ValuesControlValueAccessor],
                imports: [],
                exports: [ValueControlValueAccessor,
                    SelectedControlValueAccessor,
                    CheckedControlValueAccessor,
                    ArrayControlValueAccessor,
                    StatusControlValueAccessor,
                    ValuesControlValueAccessor],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BasicElementsFormLibModule, { declarations: [ValueControlValueAccessor,
        SelectedControlValueAccessor,
        CheckedControlValueAccessor,
        ArrayControlValueAccessor,
        StatusControlValueAccessor,
        ValuesControlValueAccessor], exports: [ValueControlValueAccessor,
        SelectedControlValueAccessor,
        CheckedControlValueAccessor,
        ArrayControlValueAccessor,
        StatusControlValueAccessor,
        ValuesControlValueAccessor] }); })();

/*
 * Public API Surface of basic-elements-ng-form
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ArrayControlValueAccessor, BasicElementsFormLibModule, CheckedControlValueAccessor, SelectedControlValueAccessor, StatusControlValueAccessor, ValueControlValueAccessor, ValuesControlValueAccessor };
